import { useEffect } from 'react';
import { checkCannedResponses } from '../api';

import { useConnect } from '../context/connect';

export const useCheckUpdates = () => {
  const { setCannedResponses, setShortcuts } = useConnect();

  useEffect(() => {
    const cannedResponses = window.localStorage.getItem('canned_responses');
    const lastCheck = window.localStorage.getItem('last_check_time');
    const date = +new Date() - 60000;
    const needCheck = lastCheck ? +lastCheck < date : true;
    if (cannedResponses && needCheck) {
      window.connect.agent((_agent) => {
        const username = _agent.getConfiguration().username;
        checkCannedResponses(username, { setCannedResponses, setShortcuts });
      });
    }
  }, []);

  return null;
};
